import { CHUNK_LOAD_FAILED_TAG, ERROR_LEVELS, SENTRY_CABINET, WEB_VITALS_CHUNK } from 'services/Sentry/constants';
import { getChunkLoadContext, getFailedChunkEntries, getResourceEntries } from 'services/Sentry/helpers';
import sentry from 'services/Sentry/SentryInstance';

const reportWebVitals = (onPerfEntry?: (metric: { name: string; value: number }) => void) => {
    if (onPerfEntry) {
        import('web-vitals')
            .then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
                onCLS(onPerfEntry);
                onINP(onPerfEntry);
                onFCP(onPerfEntry);
                onLCP(onPerfEntry);
                onTTFB(onPerfEntry);
            })
            .catch((error) => {
                const entries = getResourceEntries();
                const failedEntries = getFailedChunkEntries(entries);

                sentry.logError(
                    error,
                    SENTRY_CABINET,
                    ERROR_LEVELS.WARNING,
                    { chunkLoad: getChunkLoadContext(entries, failedEntries) },
                    [[CHUNK_LOAD_FAILED_TAG, WEB_VITALS_CHUNK]],
                    `[${SENTRY_CABINET}] web-vitals chunk load failed: ${error}`
                );
            });
    }
};

export default reportWebVitals;
